import React, {createRef, useEffect, useRef, useState} from 'react'
import './Event.css'
import {getEvents} from "../../../fetcher";
import {withRouter} from "../../../utils/with-router";

function Event() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      const data = await getEvents();
      setEvents(data.records||[]);
    };

    fetchEvents();
  }, []);

  // 每页显示的news数量
  const [itemsPerPage, setItemsPerPage] = useState(1);
  // 根据屏幕宽度设置每页显示的news数量
  useEffect(() => {
    const updateItemsPerPage = () => {
      const width = window.innerWidth;
      if (width < 600) {
        setItemsPerPage(1);
      } else if (width < 900) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(3);
      }
    };

    updateItemsPerPage();
    // 监听屏幕宽度变化
    window.addEventListener('resize', updateItemsPerPage);

    // 组件卸载时移除监听
    return () => {
      window.removeEventListener('resize', updateItemsPerPage);
    };
  }, []);

  // 计算总页数
  const [pageNumber, setPageNumber] = useState(0);
  useEffect(() => {
    setPageNumber(Math.ceil(events.length / itemsPerPage));
  }, [itemsPerPage, events.length]);

  // index为当前页数，初始值为0即打开网页时显示第一页
  const [index, setIndex] = useState(0);
  // carouselContent为类名为event_carousel_container的div
  const carouselContent = useRef();
  // listRefs为轮播图下方的小圆点的数组
  const listRefs = useRef([]);
  listRefs.current = Array.from({ length: pageNumber }, (_, i) => listRefs.current[i] ?? createRef());

  // index改变时，更新小圆点状态和carouselContent.current.style.left
  useEffect(() => {
    carouselContent.current.style.left = (index * -100) + '%';
    // Event_old中handleDot()方法，用于toggle小圆点的active状态
    listRefs.current.forEach((item, i) => {
      if (i === index) {
        item.current.classList.add('dotActive');
      } else {
        item.current.classList.remove('dotActive');
      }
    });
  }, [index]);

  // 左右箭头的点击事件，调用setIndex()方法改变index，从而调用useEffect()方法
  const handleLeftClick = () => {
    setIndex((index + pageNumber - 1) % pageNumber);
  };

  const handleRightClick = () => {
    setIndex((index + 1) % pageNumber);
  };
  const handleDotClick = (index) => {
    setIndex(index);
    carouselContent.current.style.left  = (index * -100) + '%';
    // this.handleDot();
  };

  // 加载图片
  const getBackgroundImage = (json) => {
    if (json.fields.Photo) {
      return `${json.fields.Photo[0].url}`;
    }
    return `/assets/press1.svg`;
  };

  return (
    <div>

      <div className='event_title'>
        <div className='event_title_text'>Recent Events</div>
        <hr className='event_hr'/>
      </div>
      <div className="event_carousel">
        {/*轮播图主体*/}
        <ul
          ref={carouselContent}
          className="event_carousel_container"
          style={{width: `${pageNumber * 100}%`}}
        >
          {/*根据总页数生成对应数量的轮播页*/}
          {Array.from({ length: pageNumber }, (_, i) => (
            <li key={i} className='event_carousel_content'>
              {/*根据每页显示数量循环生成news*/}
              {Array.from({ length: itemsPerPage }, (_, j) => {
                const event = events[i * itemsPerPage + j];
                if (!event) {
                  return null;
                }
                return (
                  <div key={j} className='event_1'>
                    <img className='event_img' src={getBackgroundImage(event)} alt="pic" />
                    <div className='event_content'>
                      <a href={event.fields.URL} target="_blank" rel="noopener noreferrer" className="event_content_title removeStyle">
                        <h1>{event.fields.Name}</h1>
                      </a>
                      <div className='event_content_detail'>
                        <img className='avatar_img' alt="pic" />
                        <h4 className='event_content_speaker'>{event.fields.Speaker}</h4>
                      </div>
                      <div className='event_content_detail'>
                        <img className='calendar_img' alt="pic" />
                        <h4 className='event_content_date'>{event.fields.Date}</h4>
                      </div>
                      <div className='event_content_detail'>
                        <img className='online_img' alt="pic" />
                        <h4 className='event_content_text'>{event.fields.Type}</h4>
                      </div>
                    </div>
                  </div>
                )
              })}
            </li>
          ))}
        </ul>

        {/*轮播图下方的小圆点*/}
        <div className="event_carousel_dot_container">
          <ul className="event_carousel_dot_ul">
            {Array.from({ length: pageNumber }, (_, i) => (
              <li
                onClick={() => handleDotClick(i)}
                key={i}
                ref={listRefs.current[i]}
                className={`event_carousel_dot ${i === index ? 'dotActive' : ''}`}
              ></li>
            ))}
          </ul>
        </div>
        <div className="center-buttons">
          <div onClick={handleLeftClick} className="e-button_left">
            <img className="e-leftButton" />
          </div>
          <div onClick={handleRightClick} className="e-button_right">
            <img className="e-rightButton"  />
          </div>

        </div>
      </div>

    </div>
  );
}

export default withRouter(Event);